import React, { useEffect, useState } from 'react'
import * as dayjs from 'dayjs'
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom'
import { requestAuth } from '../../../../http/httpRequest'
import { TabContainer } from '../../../../components/tab/TabContainer'
import { TabItem } from '../../../../components/tab/TabItem'
import { RangeDate } from '../../../../components/datePicker/CustomDateRangePicker'
import { Section } from '../../../../components/table/Section'
import { VerificationPathByString } from '../../../../utils'
import { ErrorPage } from '../../../error/errorPage'
import { ResumenGeneral } from './ResumenGeneral'
import { EmpresaDetalle } from './EmpresaDetalle'
import { slugify } from './utils'

const currentWeekRange = () => {
    const now = dayjs()
    const dayOfWeek = now.day()
    const diffToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1
    const from = now.subtract(diffToMonday, 'day').startOf('day').toDate()
    const to = dayjs(from).add(6, 'day').endOf('day').toDate()
    return { from, to }
}

export const DashboardConsolidadoTab = () => {
    const navigate = useNavigate()
    const [selectedDay, setSelectedDay] = useState(currentWeekRange())
    const [resumen, setResumen] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        navigate('general')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const getData = async () => {
            setLoading(true)
            setError(null)
            await requestAuth('get', '/reportes-consolidado', null, {
                initial: selectedDay?.from ? dayjs(selectedDay.from).format('YYYY-MM-DDTHH:mm:ss') : '',
                final: selectedDay?.to ? dayjs(selectedDay.to).format('YYYY-MM-DDTHH:mm:ss') : '',
            })
                .then((response) => setResumen(response.data))
                .catch((err) => setError(err?.response?.data?.message || 'No se pudo cargar el dashboard consolidado'))
                .finally(() => setLoading(false))
        }
        getData()
    }, [selectedDay])

    const empresas = resumen?.empresas ?? []

    return (
        <Section>
            <div className='grid gap-4 min-w-0 overflow-x-hidden'>
                <div className='relative w-fit ml-auto'>
                    <RangeDate
                        setPaginate={() => {}}
                        selectedDay={selectedDay}
                        setSelectedDay={setSelectedDay}
                        alignRight
                    />
                </div>

                {loading && (
                    <div className='text-center text-gray-500 dark:text-gray-400 py-10'>
                        <i className='fa fa-spinner fa-spin text-2xl' />
                    </div>
                )}

                {error && (
                    <div className='bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 px-4 py-2 rounded-md text-sm'>
                        {error}
                    </div>
                )}

                {!loading && resumen && (
                    <>
                        <TabContainer>
                            <TabItem
                                to='general'
                                label='GENERAL'
                                active={VerificationPathByString('/general')}
                                isChart
                            />
                            {empresas.map((empresa, idx) => (
                                <TabItem
                                    key={idx}
                                    to={slugify(empresa.nombre)}
                                    label={empresa.nombre}
                                    active={VerificationPathByString('/' + slugify(empresa.nombre))}
                                    isChart
                                />
                            ))}
                        </TabContainer>
                        <Routes>
                            <Route index element={<Navigate to='general' />} />
                            <Route path='general' element={<ResumenGeneral resumen={resumen} />} />
                            {empresas.map((empresa, idx) => (
                                <Route
                                    key={idx}
                                    path={slugify(empresa.nombre)}
                                    element={<EmpresaDetalle empresa={empresa} />}
                                />
                            ))}
                            <Route path='*' element={<ErrorPage />} />
                        </Routes>
                    </>
                )}
            </div>
        </Section>
    )
}
